import { createApp } from 'vue';
import App from './App.vue';
import router from './router/index.js';
import store from './store/index.ts';
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
import '@/assets/css/animation.css';
// // ✅ 引入并启动版本监控
// import { VersionMonitor } from '@/utils/version-monitor';
// new VersionMonitor().start();
createApp(App).use(store).use(router).use(ElementPlus).mount('#app');
